import EventEmitter from 'events';
import fscreen from 'fscreen';
import { wrap } from 'lodash-es';
import SyosEvents from './SyosEvents';
import SyosGlobalConfig from './../SyosGlobalConfig';
import syosMediaQuery from './syosMediaQuery';


class SyosFullscreenManager extends EventEmitter {
  constructor(syosController, el) {
    super();
    this.el = el;

    const screenWidth = window.screen.width;
    const maxWidth = SyosGlobalConfig.fullScreenMaxWidth;

    this.fullscreenEnabled = screenWidth <= maxWidth && fscreen.fullscreenEnabled;

    this.isCurrentlyFullscreen = false;

    this.bindMethods();
    this.wrapMethods();

    if (this.fullscreenEnabled) {
      fscreen.addEventListener('fullscreenchange', this.onFullscreenChange);
      syosController.on(SyosEvents.SCREEN_UPDATED, this.onScreenUpdate);
      syosMediaQuery.on(SyosEvents.MOBILE_LEAVE, this.exitFullscreen);
    }
  }

  bindMethods() {
    this.onScreenUpdate = this.onScreenUpdate.bind(this);
    this.onFullscreenChange = this.onFullscreenChange.bind(this);
    this.enterFullscreen = this.enterFullscreen.bind(this);
    this.exitFullscreen = this.exitFullscreen.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
  }

  wrapMethods() {
    const testFullscreenEnabled = (fn) => {
      if (this.fullscreenEnabled) {
        return fn();
      }
      return false;
    };

    this.enterFullscreen = wrap(this.enterFullscreen, testFullscreenEnabled);
    this.exitFullscreen = wrap(this.exitFullscreen, testFullscreenEnabled);
    this.toggleFullscreen = wrap(this.toggleFullscreen, testFullscreenEnabled);
  }

  onFullscreenChange() {
    this.isCurrentlyFullscreen = fscreen.fullscreenElement !== null;
  }

  onScreenUpdate({ screen }) {
    if (
      screen !== null &&
      syosMediaQuery.testIsMobile()
    ) {
      this.enterFullscreen();
    } else {
      this.exitFullscreen();
    }
  }

  getFullscreenEnabled() {
    return this.fullscreenEnabled;
  }

  toggleFullscreen() {
    if (this.isCurrentlyFullscreen) {
      return this.exitFullscreen();
    }
    return this.enterFullscreen();
  }

  enterFullscreen() {
    if (this.isCurrentlyFullscreen === false) {
      return fscreen.requestFullscreen(this.el);
    }
    return false;
  }

  exitFullscreen() {
    if (this.isCurrentlyFullscreen) {
      return fscreen.exitFullscreen();
    }
    return false;
  }
}

export default SyosFullscreenManager;



// WEBPACK FOOTER //
// ./src/syos/utils/SyosFullscreenManager.js